<template>
  <aha-modal
    noMarginPadding
    width="1084px"
    :title="modalTitle"
    :classesModal="classesModal"
    :backable="!!templateSelected"
    @back="handleBackToTemplate"
    @hide="hide"
  >
    <div class="template-library-body">
      <section v-if="!templateSelected" class="template-library-content">
        <div class="template-library-content-wrapper">
          <TemplateNavbar
            :activeTab="activeCategoryId"
            :categories="categories"
            :selectedCategoryLabel="selectedCategoryLabel"
            class="template-library-sidebar"
            @onChange="handleCategoryChange"
          />
          <div class="template-library-main">
            <CategoryResultSection
              data-max-cols="3"
              :isLoading="isLoadingTemplates"
              :categorySelected="selectedCategoryData"
              :title="selectedCategoryLabel"
              :copyType="'slides'"
              :handleClickTemplate="handleClickTemplate"
            />
          </div>
        </div>
      </section>
      <TemplatePreview
        v-if="templateSelected"
        :presentationShareCode="templateSelected.shareCode"
        :templateLocation="'template-library'"
        :isPopupMode="true"
        :where="'presentation-editor'"
        :copyType="'slides'"
      />
    </div>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TemplateNavbar from './template-container/TemplateNavbar.vue'
import CategoryResultSection from './template-container/CategoryResultSection.vue'
import TemplatePreview from '@/components-v2/template/TemplatePreview.vue'

export default {
  name: 'TemplateLibraryModal',
  components: {
    TemplateNavbar,
    CategoryResultSection,
    TemplatePreview,
  },
  data() {
    return {
      selectedCategoryLabel: '',
      activeCategoryId: null,
      templateSelected: null,
    }
  },
  computed: {
    ...mapState('templateCategory', {
      categories: (state) => state.categories,
      selectedCategoryData: (state) => state.selectedCategoryData,
      isLoadingFeaturedTemplates: (state) => state.isLoadingFeaturedTemplates,
      isLoadingCategoryDetail: (state) => state.isLoadingCategoryDetail,
    }),
    ...mapState({
      isShowModalTemplateLibrary: (state) => state.isShowModalTemplateLibrary,
    }),
    modalTitle() {
      if (this.templateSelected) {
        return this.$i18nPresenter.t('Back')
      }

      return this.$i18nPresenter.t('Templates')
    },
    classesModal() {
      return {
        'template-library-modal': true,
        backable: !!this.templateSelected,
      }
    },
    isLoadingTemplates() {
      return this.isLoadingFeaturedTemplates || this.isLoadingCategoryDetail
    },
  },
  created() {
    this.getAllCategories()
    this.getFeaturedTemplatesByCategories()
  },
  methods: {
    ...mapActions('templateCategory', [
      'getAllCategories',
      'getFeaturedTemplatesByCategories',
      'getCategoryDetail',
    ]),
    ...mapActions(['setShowModalTemplateLibraryAction']),
    hide() {
      this.setShowModalTemplateLibraryAction(false)
    },
    async handleCategoryChange(category) {
      this.activeCategoryId = category.id
      this.selectedCategoryLabel = category.label

      if (category.id) {
        this.getCategoryDetail(category.id)
      } else {
        this.getFeaturedTemplatesByCategories()
      }
    },
    handleClickTemplate(template) {
      this.templateSelected = template
    },
    handleBackToTemplate() {
      this.templateSelected = null
    },
  },
}
</script>

<style lang="scss">
// universal style
$modal-content-height: 660px;

.template-library-modal {
  .aha-modal__header {
    background-color: #fff;
    border-bottom: 1px solid #D3D7E1;
    @apply pt-6 md:pt-4;

    .aha-modal__header--text {
      align-items: center;
      @apply mt-0;
    }
  }

  &.backable {
    .aha-modal__header {
      .aha-modal__header--text {
        .aha-modal__header--text-content {
          @apply hidden md:inline-block;
        }
      }
    }
  }

  .aha-modal__content {
    background-color: #F0F4FA;
  }

  @media (min-width: 768px) {
    .template-preview {
      &.--loading {
        position: absolute;
        width: 100%;
        height: $modal-content-height;
      }

      .template-details {
        height: $modal-content-height;
        padding-top: 20px;
        overflow-y: auto;
      }

      .slides-header {
        display: none;
      }

      .template-slides.has-fixed-height {
        height: $modal-content-height;
        padding-top: 20px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$template-library-body-height: 660px;

.template-library-body {
  @media (min-width: 768px) {
    height: $template-library-body-height;
    overflow-y: auto;
  }
}

.template-library-content {
  padding: 20px;

  .template-library-content-wrapper {
    @apply grid xl:gap-x-5;

    @media (min-width: 1280px) {
      grid-template-columns: 200px 1fr;
    }
  }

  .template-library-sidebar {
    @apply col-span-12 mb-5 xl:col-auto;
  }

  .template-library-main {
    @apply col-span-12 xl:overflow-hidden xl:col-auto;
  }
}
</style>
